export function LineDelimiter(){
    return(
        <div
            style={{
                marginTop: '7px',
                marginBottom: '7px',
                borderBottom: 'solid 1px #bdbcbc',
            }}
        />
    );
}